export enum Path {
  Home = '/',
  GameSettings = '/settings',
  Phone = '/phone',
  PhoneConfirmation = '/phone-confirmation',
  PaymentMethod = '/payment-method',
  PaymentSuccess = '/payment-success',
  StartGame = '/start-game',
  Game = '/game',
  PostGame = '/post-game',
  NotFoundPage = '/not-found',
  BettingLimit = '/betting-limit',
}
